import styled from "@emotion/styled";

import {borderRadius, pointer} from "@pg-design/helpers-css";

export const TdaMobileWrap = styled.div`
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    width: 100%;
    margin: 0 auto;
    ${pointer};
    ${borderRadius(2)};
    overflow: hidden;

    img {
        width: 100%;
        height: auto;
        max-height: 100%;
    }

    @media (min-width: 400px) {
        width: 375px;
        height: 484px;
    }
`;
import styled from "@emotion/styled";

import {borderRadius, pointer} from "@pg-design/helpers-css";

export const TdaMobileWrap = styled.div`
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    width: 100%;
    margin: 0 auto;
    ${pointer};
    ${borderRadius(2)};
    overflow: hidden;

    img {
        width: 100%;
        height: auto;
        max-height: 100%;
    }

    @media (min-width: 400px) {
        width: 375px;
        height: 484px;
    }
`;
